<script>
    // date-fns
    import formatDistance from 'date-fns/formatDistance';

    export let date;
    export let style;

    let cls;
    export {cls as class};

    $: display = formatDistance(date, new Date(), { addSuffix: true });
</script>

<span class="timeago {cls}" {style}>{display}</span>